import { Components, Theme } from "@mui/material";

declare module "@mui/material/TextField" {}

export const MuiTextField: Components<Theme>["MuiTextField"] = {
  styleOverrides: {
    root: {
      ".MuiInputBase-root": {
        background: "white",
      },
    },
  },
};
